import { useEffect } from "react";
import Lenis from "lenis";
import { EnquiryProvider } from "../context/EnquiryContext";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Catalog from "../components/Catalog";
import Quality from "../components/Quality";
import About from "../components/About";
import Compliance from "../components/Compliance";
import EnquiryForm from "../components/EnquiryForm";
import Referral from "../components/Referral";
import Reviews from "../components/Reviews";
import Footer from "../components/Footer";

export default function Home() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <EnquiryProvider>
            <div className="grain min-h-screen bg-[#F8FAFC]" data-testid="home-page">
                <Header />
                <main>
                    <Hero />
                    <Marquee />
                    <Catalog />
                    <Quality />
                    <About />
                    <Compliance />
                    <EnquiryForm />
                    <Referral />
                    <Reviews />
                </main>
                <Footer />
            </div>
        </EnquiryProvider>
    );
}
